module.exports = __webpack_public_path__ + "static/media/icon-score-2-scale-5.fb5a997f.png";